import {useState} from 'react';
import {useViewportEffect} from 'react-viewport-utils';

export const useIsScrollingUp = ({
  bottomLimit,
}: {
  bottomLimit?: number;
} = {}) => {
  const [isVisible, setIsVisible] = useState(false);

  useViewportEffect(
    ({scroll, dimensions}) => {
      const dimensionsHeight = bottomLimit ?? dimensions.height;

      if (scroll.y < dimensionsHeight) {
        setIsVisible(false);
        return;
      }

      if (scroll.isScrollingUp) {
        setIsVisible(true);
        return;
      }

      const scrollDownLimit = Math.max(
        dimensionsHeight,
        dimensions.documentHeight - dimensionsHeight,
      );

      setIsVisible(scroll.y > scrollDownLimit);
    },
    {
      priority: 'low',
    },
    [bottomLimit],
  );

  return isVisible;
};
